module.exports = __webpack_public_path__ + "img/pp12.d9d84690.png";